
import {
  defineComponent, onMounted, onUpdated, ref, Ref,
} from 'vue';
import { HIDE_BORDER } from '@/types/enums';
import DriveUiWrapper from './DriveUIWrapper.vue';

export default defineComponent({
  props: {
    title: { type: String, reqiured: true },
    modelValue: { type: String, default: '' },
    bold: { type: Boolean, default: false },
    hideBorder: { type: Number as () => HIDE_BORDER, default: HIDE_BORDER.NONE },
    error: { type: String, default: '' },
    disabledEnter: { type: Boolean, default: false },
    enterkeyhint: { type: String, default: 'enter' },
  },
  components: {
    DriveUiWrapper,
  },
  setup(props, { emit }) {
    const input: Ref<HTMLElement | null> = ref(null);

    // function autosize() {
    //   // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    //   input.value!.style.height = '10px';
    //   // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    //   input.value!.style.height = `${input.value!.scrollHeight}px`;
    // }

    function onInput(event: Event) {
      emit('update:modelValue', (event.target as HTMLInputElement).value);
    }

    function onEnter(event: Event) {
      if (props.disabledEnter) {
        event.preventDefault();
      }
      emit('onEnter');
    }

    // onMounted(() => {
    //   autosize();
    // });

    // onUpdated(() => {
    //   autosize();
    // });

    return {
      input,
      // autosize,
      onInput,
      onEnter,
    };
  },
});
